import '@mdi/font/css/materialdesignicons.css';
import { ar, en } from 'vuetify/locale';
import { createVuetify } from 'vuetify';
import { VTable, VRadio, VCheckbox } from 'vuetify/components';

import 'vuetify/lib/components/VTable/VTable.sass';
import 'vuetify/lib/components/VCheckbox/VCheckbox.sass';

export default defineNuxtPlugin(({ vueApp }: any) => {
  const locale = vueApp?.config?.globalProperties?.$i18n?.locale || 'ar';

  const vuetify = createVuetify({
    ssr: false,
    locale: {
      locale: String(locale),
      fallback: 'ar',
      messages: { ar, en },
    },
    components: {
      VTable,
      VRadio,
      VCheckbox,
    },
    defaults: {
      global: {
        elevation: 0,
      },
    },
  });

  vueApp.use(vuetify);
});
